import LocalizedStrings from 'react-localization';
import { withCommon } from '../../services/common.translations';

const strings = new LocalizedStrings({
  en: {
    message: 'An error occured.',
    showDetails: 'Show Details',
    hideDetails: 'Hide Details',
    goHome: 'Go home',
    tryAgain: 'Try again'
  }
});

export default withCommon<typeof strings>(strings);
